import { TActions } from '../../../AppModulesWrapper';

import { UPDATE_USER_BALANCE } from '../../actions/user';
import { IUserState } from '../../types/reducers/user';
import { SET_USER } from '../../actions/user/setUser';

export const userDefaultState = {};

export function user(state: IUserState, action: TActions): IUserState {
  switch (action.type) {
    case SET_USER: {
      return action.payload;
    }

    case UPDATE_USER_BALANCE:
      return {
        ...state,
        balance: action.payload.balance,
      };

    default:
      return state || userDefaultState;
  }
}
